"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** Клик по одной из кнопок в отклике. Клика по кнопке "Оставить отзыв" (отзыв о собеседовании), нет т.к. он залогирован тут docs/web-analytics/docs/xhh/applicant/interview_review/interview_review_creation_open_button_click.md */
const negotiationItemButtonClick = ({ buttonName, vacancyId, negotiationTopicId, screenType, ...analyticsParams }) => analytics_js_1.default.sendHHEventButtonClick(buttonName, { buttonName, vacancyId, negotiationTopicId, screenType, ...analyticsParams });
exports.default = negotiationItemButtonClick;
